// extracted by mini-css-extract-plugin
export default {"translationModeBar":"TranslationModeBar_translationModeBar__oO1qw"};